import React from "react";

const Projects = () => {
  return (
    <div id="fh5co-work" className="fh5co-bg-dark">
      <div className="container">
        <div className="row animate-box">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>Projects</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 text-center col-padding animate-box">
            <div className="project-card" role="article">
              <div
                className="project-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-1.jpg)` }}
                role="img"
                aria-label="Distributed Key-Value Store Project"
              ></div>
              <div className="project-info">
                <h3>Distributed Key-Value Store</h3>
                <span>C++, gRPC, RocksDB</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center col-padding animate-box">
            <div className="project-card" role="article">
              <div
                className="project-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-2.jpg)` }}
                role="img"
                aria-label="Distributed Message Queue Project"
              ></div>
              <div className="project-info">
                <h3>Distributed Message Queue</h3>
                <span>Java, gRPC, Zookeeper</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center col-padding animate-box">
            <div className="project-card" role="article">
              <div
                className="project-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-3.jpg)` }}
                role="img"
                aria-label="ML-based Recommendation System Project"
              ></div>
              <div className="project-info">
                <h3>ML-based Recommendation System</h3>
                <span>Python, TensorFlow, AWS</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center col-padding animate-box">
            <div className="project-card" role="article">
              <div
                className="project-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-4.jpg)` }}
                role="img"
                aria-label="Real-time Data Processing Pipeline Project"
              ></div>
              <div className="project-info">
                <h3>Real-time Data Processing Pipeline</h3>
                <span>Kafka, Spark, Elasticsearch</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center col-padding animate-box">
            <div className="project-card" role="article">
              <div
                className="project-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-5.jpg)` }}
                role="img"
                aria-label="IoT Device Management Platform Project"
              ></div>
              <div className="project-info">
                <h3>IoT Device Management Platform</h3>
                <span>React, Node.js, MongoDB</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center col-padding animate-box">
            <div className="project-card" role="article">
              <div
                className="project-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-6.jpg)` }}
                role="img"
                aria-label="Cloud-based Content Delivery Network Project"
              ></div>
              <div className="project-info">
                <h3>Cloud-based Content Delivery Network</h3>
                <span>AWS CloudFront, Lambda, S3</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center col-padding animate-box">
            <div className="project-card" role="article">
              <div
                className="project-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-7.jpg)` }}
                role="img"
                aria-label="Containerized Microservices Deployment Project"
              ></div>
              <div className="project-info">
                <h3>Containerized Microservices Deployment</h3>
                <span>Docker, Kubernetes, Helm</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 text-center col-padding animate-box">
            <div className="project-card" role="article">
              <div
                className="project-image"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-8.jpg)` }}
                role="img"
                aria-label="Personal Portfolio Website Project"
              ></div>
              <div className="project-info">
                <h3>Personal Portfolio Website</h3>
                <span>React, Tailwind CSS, Framer Motion</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
